module.exports = __webpack_public_path__ + "static/media/clients.0dc7e8e2.svg";